// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ResearcherList-cls1__b2f8180a10e6bbd1488d{/*!*/}.ResearcherList-cls2___f37194712b3bdddaedf{}@media(max-width: 567px){.ResearcherList-cls2___f37194712b3bdddaedf{margin-left:48px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ResearcherList-cls1__b2f8180a10e6bbd1488d",
	"cls2": "ResearcherList-cls2___f37194712b3bdddaedf ResearcherList-cls1__b2f8180a10e6bbd1488d"
};
export default ___CSS_LOADER_EXPORT___;
